import { render, staticRenderFns } from "./dealerBGI-CA.vue?vue&type=template&id=06936ad1&"
import script from "./dealerBGI-CA.vue?vue&type=script&lang=js&"
export * from "./dealerBGI-CA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports